// extracted by mini-css-extract-plugin
export var diagram = "styles-module--diagram--1982f";
export var intro = "styles-module--intro--5677c";
export var wrapper = "styles-module--wrapper--888c3";